module.exports = __webpack_public_path__ + "img/trgl-3.da49dab4.svg";